import React, { Component } from 'react';
import ChevronDown from 'sushiweb/Icons/all/ChevronDown';
import ChevronUp from 'sushiweb/Icons/all/ChevronUp';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router";

import './SummaryPage.scss';
import SummaryTable from './SummaryTable';
import { ISSUE_SUMMARY_MODAL } from './../../../operations/tableModal';
import { getOrderProducts, getAllIssueReasons } from './../../../actions/ordersAction';

class IssuesSummary extends Component {
  constructor() {
    super();
    this.state = {
      showDetails: false
    }
  }

  componentDidMount = () => {
    const orderId = this.props.match.params.id;
    this.props.actions.getOrderProducts(orderId);
    this.props.actions.getAllIssueReasons('productIssue');
  }

  showHideDetails = () => {
    const {showDetails} = this.state;
    this.setState({showDetails: !showDetails});
  }

  filterProductWithIssues = () => {
    const {products, allReasons} = this.props;
    const productWithIssues = [];
    products.forEach(product => {
      if(product.issue) {
        let {issue} = product;
        issue = { ...issue, item: product.skuName, quantityDispatched: product.quantityDispatched, measurementUnit: product.measurementUnit};
        const reason = allReasons.filter(reason => reason.id === issue.reasonId);
        if(reason.length) {
          issue = { ...issue, reasonId: reason[0].name };
        }
        productWithIssues.push(issue);
      }
    });
    return productWithIssues;
  }

  render() {
    const {showDetails} = this.state;
    const productWithIssues = this.filterProductWithIssues() || [];
    const { products } = this.props;
    return (
      <div className="container fs-14">
        <div className="pd-bottom-20 pd-top-20 fs-16 w-600">Issues</div>
        <div>
          <div>
            <span className="mr-2">Total Items</span>
            <span className="w-600">{products.length}</span>
          </div>
          <div>
            <span className="mr-2">Issue Items</span>
            <span className="w-600">{`${productWithIssues.length}/${products.length}`}</span>
          </div>
          {showDetails && <SummaryTable 
            className="mt-2"
            modal={ISSUE_SUMMARY_MODAL}
            content={productWithIssues}
            />}
          <div className="green-text flex pd-top-20 w-600" onClick={() => this.showHideDetails()}>
            {!showDetails ?  "View Details" : "Hide Details" }
            {!showDetails ? <ChevronDown className="ml-1 icon-medium icon-color-green" />: <ChevronUp className="ml-1 icon-medium icon-color-green" />}
          </div>
          <div className="light-line "></div>
        </div>
      </div>
    )
  }
}


const actions = { getOrderProducts, getAllIssueReasons }
export default withRouter(connect(
  state => ({
    products: state.orders.orderProducts || [],
    allReasons: state.orders.reasons || []
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(IssuesSummary));
